import { Upload, Users, FileText, FileCheck, CheckCircle, Clock, PenTool } from "lucide-react";

const WorkflowSection = () => {
  const steps = [
    {
      number: "01",
      icon: Upload,
      title: "Send Dictations",
      description: "Providers send dictations via secure platform",
    },
    {
      number: "02",
      icon: Users,
      title: "Team Receives",
      description: "Dictation Team receives the recordings",
    },
    {
      number: "03",
      icon: FileText,
      title: "Transcription",
      description: "Dictation Team transcribes accordingly",
    },
    {
      number: "04",
      icon: FileCheck,
      title: "Chart Update",
      description: "Team updates charts in Fluency for signing",
    },
    {
      number: "05",
      icon: CheckCircle,
      title: "Quality Review",
      description: "Compliance check for accuracy & formatting",
    },
    {
      number: "06",
      icon: Clock,
      title: "Ready in 24hrs",
      description: "Charts ready for signing within 24 hours",
    },
    {
      number: "07",
      icon: PenTool,
      title: "Provider Signs",
      description: "Providers review and sign the chart",
    },
  ];

  return (
    <section 
      id="workflow"
      data-testid="workflow-section"
      className="py-16 sm:py-24 md:py-32 bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <span className="text-xs sm:text-sm font-medium uppercase tracking-widest text-cyan-500 mb-3 sm:mb-4 block">
            How It Works
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-white mb-3 sm:mb-4">
            What Is the Workflow?
          </h2>
          <p className="text-base sm:text-lg text-slate-400 max-w-2xl mx-auto px-4">
            A streamlined 7-step process designed for efficiency and accuracy
          </p>
        </div>

        {/* Workflow Steps - Desktop */}
        <div className="hidden lg:block">
          <div className="relative">
            {/* Connection Line */}
            <div className="absolute top-12 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-cyan-500/30 to-transparent" />
            
            {/* Steps Grid */}
            <div className="grid grid-cols-7 gap-4">
              {steps.map((step, index) => (
                <div key={index} className="relative text-center group">
                  {/* Step Circle */}
                  <div className="relative z-10 mx-auto w-24 h-24 rounded-2xl bg-[#111] border border-white/10 flex flex-col items-center justify-center mb-4 group-hover:border-cyan-500/30 group-hover:bg-cyan-500/5 transition-all duration-300">
                    <span className="text-xs text-cyan-500 font-medium mb-1">{step.number}</span>
                    <step.icon className="w-6 h-6 text-cyan-400" />
                  </div>
                  
                  {/* Title & Description */}
                  <h4 className="text-sm font-semibold text-white mb-2">{step.title}</h4>
                  <p className="text-xs text-slate-500 leading-relaxed">{step.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Workflow Steps - Mobile/Tablet */}
        <div className="lg:hidden space-y-3 sm:space-y-4">
          {steps.map((step, index) => (
            <div 
              key={index} 
              className="glass-card p-4 sm:p-6 flex items-start gap-3 sm:gap-4"
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-cyan-500/10 border border-cyan-500/20 flex flex-col items-center justify-center flex-shrink-0">
                <span className="text-[10px] sm:text-xs text-cyan-500 font-medium">{step.number}</span>
                <step.icon className="w-4 h-4 sm:w-5 sm:h-5 text-cyan-400" />
              </div>
              <div className="min-w-0">
                <h4 className="text-base sm:text-lg font-semibold text-white mb-1">{step.title}</h4>
                <p className="text-xs sm:text-sm text-slate-400">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WorkflowSection;
